import DestroyedEvent from '../../ecs/DestroyedEvent';

export default DestroyedEvent;
